export default "__VITE_ASSET__vmnDZ4h5__"